var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebinar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 165C135.899 165 165 135.899 165 100C165 64.1015 135.899 35 100 35C64.1015 35 35 64.1015 35 100C35 135.899 64.1015 165 100 165Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.854 44H33.4852C30.4076 44 27.9185 46.5607 27.9185 49.7258V144.193H175.421V49.7258C175.421 46.5607 172.932 44 169.854 44Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9185 141.41V49.5667C27.9185 46.4891 30.4076 44 33.4852 44H169.854C172.932 44 175.421 46.4891 175.421 49.5667V141.41",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.538 49.7258H39.2889C36.2145 49.7258 33.7222 52.2181 33.7222 55.2926V129.362C33.7222 132.436 36.2145 134.929 39.2889 134.929H163.538C166.613 134.929 169.105 132.436 169.105 129.362V55.2926C169.105 52.2181 166.613 49.7258 163.538 49.7258Z",
    fill: "#ECEEF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.553 141.41H119.76L116.977 144.193H83.5762L80.7928 141.41H14V146.977C14 151.565 17.7536 155.327 22.3501 155.327H178.203C182.815 155.327 186.553 151.589 186.553 146.977V141.41Z",
    fill: "#FF5000",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.628 63.4836H75.2802C72.62 63.4836 70.4634 65.6402 70.4634 68.3005V113.587C70.4634 116.247 72.62 118.403 75.2802 118.403H135.628C138.289 118.403 140.445 116.247 140.445 113.587V68.3005C140.445 65.6402 138.289 63.4836 135.628 63.4836Z",
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.05 60.3026H71.7016C69.0413 60.3026 66.8848 62.4592 66.8848 65.1195V110.406C66.8848 113.066 69.0413 115.222 71.7016 115.222H132.05C134.71 115.222 136.867 113.066 136.867 110.406V65.1195C136.867 62.4592 134.71 60.3026 132.05 60.3026Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.852 85.435L91.772 69.2245C89.9815 68.1895 87.7368 69.4822 87.7368 71.5522V103.973C87.7368 106.043 89.9771 107.336 91.772 106.301L119.852 90.0902C121.642 89.0553 121.642 86.47 119.852 85.435Z",
    fill: "#FF5000",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8848 122.808H136.867",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M115.52 126.555C117.59 126.555 119.267 124.877 119.267 122.808C119.267 120.739 117.59 119.061 115.52 119.061C113.451 119.061 111.773 120.739 111.773 122.808C111.773 124.877 113.451 126.555 115.52 126.555Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinar);
export default __webpack_public_path__ + "static/media/Webinar.802c733c7035f607a6b83fd1e7ddfc11.svg";
export { ForwardRef as ReactComponent };